import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['toggleon', 'toggleoff', 'togglevalue'];
  toggleClick() {
    if (this.toggleonTarget.style.display == 'block') {
      this.toggleonTarget.style.display = 'none';
      this.toggleoffTarget.style.display = 'block';
    } else {
      this.toggleonTarget.style.display = 'block';
      this.toggleoffTarget.style.display = 'none';
    }
  }
}
